var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZarraa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.27 8.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #1d1d1b;\n        font-family: ArialMT, Arial;\n        font-size: 6.19px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2-2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 37.26,
    height: 8.27
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6.13 5.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zara.com"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarraa);
export default __webpack_public_path__ + "static/media/zarraa.a46f45e41affcf3c8c145667b56adf08.svg";
export { ForwardRef as ReactComponent };